<div class="analyzing-dashboard">
  <div class="analyzing-dashboard__summary">
    <div class="analyzing-dashboard__summary-item">
      <div class="analyzing-dashboard__label">{{ 'workspaces.referenceDocument' | transloco }}</div>
      <div class="analyzing-dashboard__value">{{ selectedReferenceDocument?.name || '-' }}</div>
    </div>
    <div class="analyzing-dashboard__summary-item">
      <div class="analyzing-dashboard__label">{{ 'workspaces.subjectDocuments' | transloco }}</div>
      <div class="analyzing-dashboard__value">{{ reviewDocumentsProgress.length }}</div>
    </div>
    <div class="analyzing-dashboard__summary-item">
      <div class="analyzing-dashboard__label">{{ 'workspaces.progress' | transloco }}</div>
      <div class="analyzing-dashboard__value">{{ reviewProgressPercentAllDocuments }}%</div>
    </div>
    <div class="analyzing-dashboard__summary-item">
      <div class="analyzing-dashboard__label">{{ 'columns.status' | transloco }}</div>
      <div class="analyzing-dashboard__value">
        @if (loadingReviewDataComplete && !reviewDoneWithErrors) {
          {{ 'workspaces.reviewStatusCompleted' | transloco }}
        }
        @if (loadingReviewDataComplete && reviewDoneWithErrors) {
          {{ 'workspaces.reviewStatusCompletedWithErrors' | transloco }}
        }
        @if (!loadingReviewDataComplete) {
          {{ 'workspaces.reviewStatusInProgress' | transloco }}
        }
      </div>
    </div>
  </div>

  <div class="analyzing-dashboard__documents mt-10p">
    <div class="analyzing-dashboard__header">
      <div>{{ 'workspaces.document' | transloco }}</div>
      <div>{{ 'columns.docType' | transloco }}</div>
      <div>{{ 'columns.language' | transloco }}</div>
      <div>{{ 'columns.position' | transloco }}</div>
      <div>{{ 'workspaces.progress' | transloco }}</div>
    </div>

    @for (document of reviewDocumentsProgress; track document.id) {
      <div class="analyzing-dashboard__row">
        <div class="analyzing-dashboard__cell" [attr.data-label]="'workspaces.document' | transloco">
          <span class="analyzing-dashboard__name">{{ document.name }}</span>
        </div>
        <div class="analyzing-dashboard__cell" [attr.data-label]="'columns.docType' | transloco">
          {{ document.typeLabel }}
        </div>
        <div class="analyzing-dashboard__cell" [attr.data-label]="'columns.language' | transloco">
          {{ document.languageLabel }}
        </div>
        <div class="analyzing-dashboard__cell" [attr.data-label]="'columns.position' | transloco">
          {{ document.positionLabel }}
        </div>
        <div class="analyzing-dashboard__cell" [attr.data-label]="'workspaces.progress' | transloco">
          {{ document.progressPercent }}%
        </div>
      </div>
    }

    @if (!reviewDocumentsProgress.length) {
      <div class="analyzing-dashboard__empty">{{ 'workspaces.noReviewDocumentsSelected' | transloco }}</div>
    }
  </div>
</div>

<div class="row mt-10p">
  <div class="col fw-600 fs-14p">
    {{ 'workspaces.analyzingProgressText' | transloco }}
  </div>
</div>

<div class="analyzing-dashboard__clauses mt-10p mb-10p">
  @for (clause of clauseProgress; track clause.id) {
    <div class="analyzing-dashboard__clause-row">
      <div class="analyzing-dashboard__clause-name">{{ clause.name }}</div>

      <div class="clause-variance-progressbar__track analyzing-dashboard__clause-track">
        <div
          class="clause-variance-progressbar__fill"
          [style.width.%]="clause.visibleProgressPercent"
        ></div>
        <div class="analyzing-dashboard__clause-progress-label">{{ clause.progressPercent }}%</div>
      </div>
    </div>
  }

  @if (!clauseProgress.length) {
    <div class="analyzing-dashboard__empty">{{ 'workspaces.noClausesAvailable' | transloco }}</div>
  }
</div>

<!-- <div class="analyzing-dashboard__occurrence-table">
  <div class="analyzing-dashboard__documents">
    <div class="analyzing-dashboard__header analyzing-dashboard__header--occurrences">
      <div>{{ 'workspaces.clauseId' | transloco }}</div>
      <div>{{ 'workspaces.name' | transloco }}</div>
      <div>{{ 'workspaces.occurrences' | transloco }}</div>
      <div>{{ 'workspaces.greenFlagType' | transloco }}</div>
    </div>

    @for (clauseStat of clauseOccurrenceStats; track clauseStat.id) {
      <div class="analyzing-dashboard__row analyzing-dashboard__row--occurrences">
        <div class="analyzing-dashboard__cell" [attr.data-label]="'workspaces.clauseId' | transloco">{{ clauseStat.id }}</div>
        <div class="analyzing-dashboard__cell" [attr.data-label]="'workspaces.name' | transloco">{{ clauseStat.name }}</div>
        <div class="analyzing-dashboard__cell" [attr.data-label]="'workspaces.occurrences' | transloco">
          {{ clauseStat.occurrencesCount }}
        </div>
        <div class="analyzing-dashboard__cell" [attr.data-label]="'workspaces.greenFlagType' | transloco">
          {{ clauseStat.greenFlagTypeOccurrencesCount }}
        </div>
      </div>
    }

    @if (!clauseOccurrenceStats.length) {
      <div class="analyzing-dashboard__empty">{{ 'workspaces.noClauseOccurrenceDataAvailable' | transloco }}</div>
    }
  </div>
</div> -->

<!-- <div class="analyzing-dashboard__document-clauses mt-2">
  @for (document of reviewDocumentClauses; track document.documentId) {
    <div class="analyzing-dashboard__document-clauses-card">
      <div class="analyzing-dashboard__document-clauses-title">{{ document.documentName }}</div>

      <div class="analyzing-dashboard__document-clauses-table">
        <div class="analyzing-dashboard__header analyzing-dashboard__header--clauses">
          <div>{{ 'workspaces.clauseId' | transloco }}</div>
          <div>{{ 'workspaces.name' | transloco }}</div>
          <div>{{ 'workspaces.flagType' | transloco }}</div>
        </div>

        @for (clause of document.clauses; track clause.id) {
          <div class="analyzing-dashboard__row analyzing-dashboard__row--clauses">
            <div class="analyzing-dashboard__cell" [attr.data-label]="'workspaces.clauseId' | transloco">{{ clause.id }}</div>
            <div class="analyzing-dashboard__cell" [attr.data-label]="'workspaces.name' | transloco">{{ clause.name }}</div>
            <div class="analyzing-dashboard__cell" [attr.data-label]="'workspaces.flagType' | transloco">
              {{ clause.flagType }}
            </div>
          </div>
        }
      </div>
    </div>
  } 

  @if (!reviewDocumentClauses.length) {
    <div class="analyzing-dashboard__empty">{{ 'workspaces.noReviewedClauseDataAvailable' | transloco }}</div>
  }
</div>
-->
